import VolunteerForm from "../components/VolunteerForm";
import Reveal from "../components/Reveal";

export default function Volunteers() {
  return (
    <>
      <section className="container-prose pt-16 sm:pt-24 pb-10 relative">
        <div
          aria-hidden
          className="orb -top-20 left-1/3 h-72 w-72 animate-float"
          style={{ background: "radial-gradient(closest-side, #aee8c7, transparent)" }}
        />
        <Reveal>
          <span className="pill pill-mint">Volunteer</span>
          <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
            We don't need your money. We could use <em className="not-italic grad-text">your time.</em>
          </h1>
          <p className="mt-6 text-lg text-ink-500 leading-relaxed">
            Sanctology is funded by our sibling Logy companies, so we don't
            fundraise. What we rely on is a network of humans — doctors,
            teachers, cooks, drivers, and kind neighbours — who give a few
            hours a week and change the rhythm of daily life for an elder or a
            child.
          </p>
        </Reveal>
      </section>

      <section className="container-prose py-10">
        <div className="grid gap-5 sm:grid-cols-2">
          <Reveal>
            <div className="surface h-full">
              <h3 className="font-display text-2xl">Direct care</h3>
              <p className="mt-3 text-ink-500 leading-relaxed text-sm">
                Spending time with residents — reading together, tutoring a
                child, sitting with an elder, helping with meals. The work
                that makes a shelter a home.
              </p>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="surface h-full">
              <h3 className="font-display text-2xl">Specialist skills</h3>
              <p className="mt-3 text-ink-500 leading-relaxed text-sm">
                Doctors, nurses, pharmacists, lawyers, teachers, counsellors,
                accountants — even a few hours a month moves the needle.
                Remote help is just as valuable.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="container-prose pt-8 pb-24">
        <Reveal>
          <div className="mb-6">
            <h2 className="font-display text-4xl">Volunteer registration</h2>
            <p className="mt-3 text-ink-500 leading-relaxed">
              Takes under a minute. Every submission gets a personal response.
            </p>
          </div>
        </Reveal>
        <Reveal delay={100}>
          <VolunteerForm />
        </Reveal>
      </section>
    </>
  );
}
